const state = {
  logged: {},
  overrideAccount: null,
};

const mutations = {
  setCurrent(currentState, user) {
    currentState.logged = user;
  },
  setOverrideAccount(currentState, siteKey) {
    currentState.overrideAccount = siteKey;
  },
};

export { mutations, state };
